import { useState } from "react";
import { useInstrumentStore } from "../../state/instrumentStore";
import { getAudioEngine } from "../../audio/AudioEngine";
import { MAX_BPM, MIN_BPM } from "../../constants/layout";
import { ParentGate } from "../ParentGate/ParentGate";
import "./Transport.css";

export function Transport() {
  const playing = useInstrumentStore((s) => s.playing);
  const bpm = useInstrumentStore((s) => s.bpm);
  const setPlaying = useInstrumentStore((s) => s.setPlaying);
  const setBpm = useInstrumentStore((s) => s.setBpm);
  const clearAll = useInstrumentStore((s) => s.clearAll);
  const openAdvanced = useInstrumentStore((s) => s.openAdvanced);

  const [gateOpen, setGateOpen] = useState(false);

  const handlePlay = async () => {
    const engine = getAudioEngine();
    if (!playing) {
      await engine.start(bpm);
      setPlaying(true);
    } else {
      engine.stop();
      setPlaying(false);
    }
  };

  const handleRewind = async () => {
    const engine = getAudioEngine();
    const wasPlaying = playing;
    engine.stop();
    setPlaying(false);
    if (wasPlaying) {
      await engine.start(bpm);
      setPlaying(true);
    }
  };

  const handleBpm = (value: number) => {
    setBpm(value);
    getAudioEngine().setBpm(value);
  };

  const confirmClear = () => {
    clearAll();
    getAudioEngine().stop();
    setPlaying(false);
    const engine = getAudioEngine();
    (["drums", "keys", "bass", "lead"] as const).forEach((track) => {
      engine.setFx(track, "volume", 0.85);
      engine.setFx(track, "fuzz", 0);
      engine.setFx(track, "delay", 0);
      engine.setFx(track, "reverb", 0);
    });
    setGateOpen(false);
  };

  return (
    <div className="transport">
      <button
        type="button"
        className="transport-title"
        onClick={openAdvanced}
        aria-label="Open parent mode"
      >
        PHINSTRUMENT
      </button>
      <button
        type="button"
        className="transport-rewind"
        onClick={handleRewind}
        aria-label="Rewind to beginning"
      >
        ⏮
      </button>
      <button
        type="button"
        className={`transport-play ${playing ? "is-playing" : ""}`}
        onClick={handlePlay}
        aria-label={playing ? "Stop" : "Play"}
      >
        {playing ? "⏹" : "▶"}
      </button>

      <label className="transport-bpm">
        <span className="transport-bpm-label">SPEED</span>
        <input
          type="range"
          min={MIN_BPM}
          max={MAX_BPM}
          value={bpm}
          onChange={(e) => handleBpm(Number(e.target.value))}
          aria-label="Tempo in BPM"
        />
        <span className="transport-bpm-value">{bpm}</span>
      </label>

      <button
        type="button"
        className="transport-clear"
        onClick={() => setGateOpen(true)}
        aria-label="Clear all"
      >
        CLEAR
      </button>

      {gateOpen && (
        <ParentGate
          title="Clear everything?"
          onConfirm={confirmClear}
          onCancel={() => setGateOpen(false)}
        />
      )}
    </div>
  );
}
